// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getCertificaciones as listCertificacionesAPI,
    getCertificacion as getCertificacionAPI,
    addCertificacion as addCertificacionAPI,
    updateCertificacion as updateCertificacionAPI,
    deleteCertificacion as deleteCertificacionAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { certificacionesApiResponseError, certificacionesApiResponseSuccess } from './actions';
import { CertificacionesActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getCertificacion({ payload: { id } }) {
    try {
        const response = yield call(getCertificacionAPI, id );
        const certificacionItem = response.data.data;
        yield put(certificacionesApiResponseSuccess(CertificacionesActionTypes.GET_CERTIFICACION, certificacionItem));
    } catch (error) {
        yield put(certificacionesApiResponseError(CertificacionesActionTypes.GET_CERTIFICACION, error));
    }
}

function* addCertificacion({payload:certificacion}){
    try{
        const response = yield call(addCertificacionAPI,{...certificacion})
        const certificacionItem = response.data
        yield put(certificacionesApiResponseSuccess(CertificacionesActionTypes.ADD_CERTIFICACION,certificacionItem))
    } catch(error){
        yield put(certificacionesApiResponseError(CertificacionesActionTypes.ADD_CERTIFICACION,error))
    }
}

function* updateCertificacion({payload:certificacion}){
    try{
        const response = yield call(updateCertificacionAPI,{...certificacion})
        const certificacionItem = response.data.data
        yield put(certificacionesApiResponseSuccess(CertificacionesActionTypes.UPDATE_CERTIFICACION,certificacionItem))
    }catch(error){
        yield put(certificacionesApiResponseError(CertificacionesActionTypes.UPDATE_CERTIFICACION,error))
    }
}
function* deleteCertificacion({payload:{id}}){
    try{
        const response = yield call(deleteCertificacionAPI,id)
        const certificacionItem = response.data.id
        yield put(certificacionesApiResponseSuccess(CertificacionesActionTypes.DELETE_CERTIFICACION,certificacionItem))
    }catch(error){
        yield put(certificacionesApiResponseError(CertificacionesActionTypes.DELETE_CERTIFICACION,error))
    }
}

/**
 * List contactos
 */
function* listCertificaciones({payload:params}) {
    try {
        const response = yield call(listCertificacionesAPI, { ...params });
        const listaCertificaciones = response.data.data;
        yield put(certificacionesApiResponseSuccess(CertificacionesActionTypes.LIST_CERTIFICACIONES, listaCertificaciones));
    } catch (error) {
        yield put(certificacionesApiResponseError(CertificacionesActionTypes.LIST_CERTIFICACIONES, error));
    }
}


export function* watchGetCertificacion(): any {
    yield takeEvery(CertificacionesActionTypes.GET_CERTIFICACION, getCertificacion);
}

export function* watchListCertificaciones(): any {
    yield takeEvery(CertificacionesActionTypes.LIST_CERTIFICACIONES, listCertificaciones);
}

export function* watchAddCertificacion():any{
    yield takeEvery(CertificacionesActionTypes.ADD_CERTIFICACION,addCertificacion)
}
export function* watchUpdateCertificacion():any{
    yield takeEvery(CertificacionesActionTypes.UPDATE_CERTIFICACION,updateCertificacion)
}
export function* watchDeleteCertificacion():any{
    yield takeEvery(CertificacionesActionTypes.DELETE_CERTIFICACION,deleteCertificacion)
}


function* certificacionesSaga(): any {
    yield all([
        fork(watchGetCertificacion),
        fork(watchListCertificaciones),
        fork(watchAddCertificacion),
        fork(watchUpdateCertificacion),
        fork(watchDeleteCertificacion),
    ]);
}

export default certificacionesSaga;
